import React, { useEffect, useState } from "react";
import { Button, Box, Typography } from "@mui/material";
import style from "../../../../styles/brsr/general.module.css";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { validateFields } from "../../../../utils/validateTable";
import RadioButtons from "../../../Common/RadioButtons";
import InputField from "../../../Masters/InputField";
import Multiline from "../../../Masters/Multiline";
import CircleIcon from "@mui/icons-material/Circle";
import {
  validateNumber,
  validateNumberInput,
  validatePercentageInput,
} from "../../../../utils/validateFields";
import {
  numberError,
  percentageError,
} from "../../../../utils/validationMessage";
import SingleColumn from "./SingleColumn";
import TableData from "../../../Common/TableData";
import MessagePopup from "../../../Masters/MessagePopup";
import { useParams } from "react-router-dom";
import { brsrReview } from "../../../../utils/companyId";
import ReviewBox from "../../../Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";
import BRSRFile from "../../../Common/BRSRFile";

const inputData = {
  // 1
  currentYearData: [
    {
      fieldName: "currentFinancialYear",
      type: "array",
      fields: [
        {
          fieldName: "received",
          title: "Received",
          placeholder: "Enter Number",
          type: "number",
          width: "7rem",
        },
        {
          fieldName: "pendings",
          title: "Pending",
          placeholder: "Enter Number",
          type: "number",
          width: "7rem",
        },
        {
          fieldName: "remark",
          title: "Remarks",
          placeholder: "Enter Text",
          type: "string",
          width: "18rem",
        },
      ],
    },
  ],
  productData: [
    {
      fieldName: "productRecalls",
      type: "array",
      fields: [
        {
          fieldName: "number",
          title: "Number",
          placeholder: "Enter Number",
          type: "number",
          width: "8rem",
        },
        {
          fieldName: "reasonForRecall",
          title: "Reason For Recall",
          placeholder: "Enter Text",
          type: "string",
          width: "20rem",
        },
      ],
    },
  ],
};

const EssentialIndicator = ({
  onSave,
  hide,
  removeUpload = false,
  downloadMode = false,
}) => {
  const [modalupload, setModalUpload] = useState({
    complaintMechanismsDoc: false,
    turnoverDoc: false,
    consumerComplaintsDoc: false,
    productRecallsDoc: false,
    cyberSecurityDoc: false,
    correctiveActionsDoc: false,
    dataBreachDetailsDoc: false,
  });
  const { id } = useParams();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState([]);
  const [formData2, setFormData2] = useState({});
  const [disabled, setDisabled] = useState(false);

  const defaultSegments = {
    currentFinancialYear: [
      { title: "Data privacy", field: "dataPrivacy" },
      { title: "Advertising", field: "advertising" },
      { title: "Cyber-security", field: "cyberSecurity" },
      {
        title: "Delivery of essential services",
        field: "deliveryEssentialServices",
      },
      {
        title: "Restrictive Trade Practices",
        field: "restrictiveTradePractices",
      },
      { title: "Unfair Trade Practices", field: "unfairTradePractices" },
      { title: "Other", field: "other" },
    ],
    products: [
      { title: "Voluntary recalls", field: "voluntaryRecalls" },
      {
        title: "Forced recalls",
        field: "forcedRecalls",
      },
    ],
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(
        `/brsr/get?subType=principle9&type=SectionC&id=${id}`,
      );
      if (
        res?.data?.data?.year
          ? res?.data?.data?.year < currentYear - 1
          : false || !brsrReview
      )
        setDisabled(true);

      const res1 = res.data.data.BRSRSectionC.principle9.essentialIndicators;
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  const [formData, setFormData] = useState({});

  useEffect(() => {
    let data1 = {
      complaintMechanismsDoc: data?.complaintMechanismsDoc ?? [],
      turnoverDoc: data?.turnoverDoc ?? [],
      consumerComplaintsDoc: data?.consumerComplaintsDoc ?? [],
      productRecallsDoc: data?.productRecallsDoc ?? [],
      cyberSecurityDoc: data?.cyberSecurityDoc ?? [],
      correctiveActionsDoc: data?.correctiveActionsDoc ?? [],
      dataBreachDetailsDoc: data?.dataBreachDetailsDoc ?? [],
      //1
      consumerComplaintsMechanisms: data?.consumerComplaintsMechanisms,
      //2
      turnoverPercentageWithInformation: {
        environmentalAndSocialParameters:
          data?.turnoverPercentageWithInformation
            ?.environmentalAndSocialParameters,
        safeAndResponsibleUsage:
          data?.turnoverPercentageWithInformation?.safeAndResponsibleUsage,
        recyclingAndSafeDisposal:
          data?.turnoverPercentageWithInformation?.recyclingAndSafeDisposal,
      },
      //3
      consumerComplaints: {
        currentFinancialYear: {
          dataPrivacy: {
            received:
              data?.consumerComplaints?.currentFinancialYear?.dataPrivacy
                ?.received ?? "",
            pendings:
              data?.consumerComplaints?.currentFinancialYear?.dataPrivacy
                ?.pendings ?? "",
            remark:
              data?.consumerComplaints?.currentFinancialYear?.dataPrivacy
                ?.remark,
          },
          advertising: {
            received:
              data?.consumerComplaints?.currentFinancialYear?.advertising
                ?.received,
            pendings:
              data?.consumerComplaints?.currentFinancialYear?.advertising
                ?.pendings,
            remark:
              data?.consumerComplaints?.currentFinancialYear?.advertising
                ?.remark ?? "",
          },
          cyberSecurity: {
            received:
              data?.consumerComplaints?.currentFinancialYear?.cyberSecurity
                ?.received,
            pendings:
              data?.consumerComplaints?.currentFinancialYear?.cyberSecurity
                ?.pendings,
            remark:
              data?.consumerComplaints?.currentFinancialYear?.cyberSecurity
                ?.remark ?? "",
          },
          deliveryEssentialServices: {
            received:
              data?.consumerComplaints?.currentFinancialYear
                ?.deliveryEssentialServices?.received,
            pendings:
              data?.consumerComplaints?.currentFinancialYear
                ?.deliveryEssentialServices?.pendings,
            remark:
              data?.consumerComplaints?.currentFinancialYear
                ?.deliveryEssentialServices?.remark ?? "",
          },
          restrictiveTradePractices: {
            received:
              data?.consumerComplaints?.currentFinancialYear
                ?.restrictiveTradePractices?.received,
            pendings:
              data?.consumerComplaints?.currentFinancialYear
                ?.restrictiveTradePractices?.pendings,
            remark:
              data?.consumerComplaints?.currentFinancialYear
                ?.restrictiveTradePractices?.remark ?? "",
          },
          unfairTradePractices: {
            received:
              data?.consumerComplaints?.currentFinancialYear
                ?.unfairTradePractices?.received,
            pendings:
              data?.consumerComplaints?.currentFinancialYear
                ?.unfairTradePractices?.pendings,
            remark:
              data?.consumerComplaints?.currentFinancialYear
                ?.unfairTradePractices?.remark ?? "",
          },
          other: {
            received:
              data?.consumerComplaints?.currentFinancialYear?.other?.received,
            pendings:
              data?.consumerComplaints?.currentFinancialYear?.other?.pendings,
            remark:
              data?.consumerComplaints?.currentFinancialYear?.other?.remark,
          },
        },
        previousFinancialYear: {
          dataPrivacy: {
            received:
              data?.consumerComplaints?.previousFinancialYear?.dataPrivacy
                ?.received,
            pendings:
              data?.consumerComplaints?.previousFinancialYear?.dataPrivacy
                ?.pendings,
            remark:
              data?.consumerComplaints?.previousFinancialYear?.dataPrivacy
                ?.remark ?? "",
          },
          advertising: {
            received:
              data?.consumerComplaints?.previousFinancialYear?.advertising
                ?.received,
            pendings:
              data?.consumerComplaints?.previousFinancialYear?.advertising
                ?.pendings,
            remark:
              data?.consumerComplaints?.previousFinancialYear?.advertising
                ?.remark ?? "",
          },
          cyberSecurity: {
            received:
              data?.consumerComplaints?.previousFinancialYear?.cyberSecurity
                ?.received,
            pendings:
              data?.consumerComplaints?.previousFinancialYear?.cyberSecurity
                ?.pendings,
            remark:
              data?.consumerComplaints?.previousFinancialYear?.cyberSecurity
                ?.remark ?? "",
          },
          deliveryEssentialServices: {
            received:
              data?.consumerComplaints?.previousFinancialYear
                ?.deliveryEssentialServices?.received,
            pendings:
              data?.consumerComplaints?.previousFinancialYear
                ?.deliveryEssentialServices?.pendings,
            remark:
              data?.consumerComplaints?.previousFinancialYear
                ?.deliveryEssentialServices?.remark ?? "",
          },
          restrictiveTradePractices: {
            received:
              data?.consumerComplaints?.previousFinancialYear
                ?.restrictiveTradePractices?.received,
            pendings:
              data?.consumerComplaints?.previousFinancialYear
                ?.restrictiveTradePractices?.pendings,
            remark:
              data?.consumerComplaints?.previousFinancialYear
                ?.restrictiveTradePractices?.remark ?? "",
          },
          unfairTradePractices: {
            received:
              data?.consumerComplaints?.previousFinancialYear
                ?.unfairTradePractices?.received,
            pendings:
              data?.consumerComplaints?.previousFinancialYear
                ?.unfairTradePractices?.pendings,
            remark:
              data?.consumerComplaints?.previousFinancialYear
                ?.unfairTradePractices?.remark ?? "",
          },
          other: {
            received:
              data?.consumerComplaints?.previousFinancialYear?.other?.received,
            pendings:
              data?.consumerComplaints?.previousFinancialYear?.other?.pendings,
            remark:
              data?.consumerComplaints?.previousFinancialYear?.other?.remark,
          },
        },
      },
      //4
      productRecalls: {
        voluntaryRecalls: {
          number:
            data?.productRecalls?.voluntaryRecalls?.number === 0
              ? 0
              : data?.productRecalls?.voluntaryRecalls?.number,
          reasonForRecall:
            data?.productRecalls?.voluntaryRecalls?.reasonForRecall,
        },
        forcedRecalls: {
          number:
            data?.productRecalls?.forcedRecalls?.number === 0
              ? 0
              : (data?.productRecalls?.forcedRecalls?.number ?? ""),
          reasonForRecall: data?.productRecalls?.forcedRecalls?.reasonForRecall,
        },
      },
      //5
      cyberSecurityAndDataPrivacyPolicy: {
        action: data?.cyberSecurityAndDataPrivacyPolicy?.action,
        webLink: data?.cyberSecurityAndDataPrivacyPolicy?.webLink,
      },
      //6
      correctiveActions: data?.correctiveActions ?? "",
      //7
      dataBreachDetails: {
        instancesOfDataBreaches:
          data?.dataBreachDetails?.instancesOfDataBreaches === 0
            ? 0
            : (data?.dataBreachDetails?.instancesOfDataBreaches ?? ""),
        percentageInvolvingPersonalData:
          data?.dataBreachDetails?.percentageInvolvingPersonalData === 0
            ? 0
            : data?.dataBreachDetails?.percentageInvolvingPersonalData,
        impactOfDataBreaches: data?.dataBreachDetails?.impactOfDataBreaches,
      },
    };
    setFormData(data1);
    setFormData2(data1);
  }, [data]);

  const [currentTable, setCurrentTable] = useState({});
  const [previousTable, setPreviousTable] = useState({});
  const [productTable, setProductTable] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    if (formData2?.consumerComplaints?.currentFinancialYear) {
      setCurrentTable(formData2?.consumerComplaints?.currentFinancialYear);
    }
    if (formData2?.consumerComplaints?.previousFinancialYear) {
      setPreviousTable(formData2?.consumerComplaints?.previousFinancialYear);
    }
    if (formData2?.productRecalls) {
      setProductTable(formData2?.productRecalls);
    }
  }, [formData2]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const [field, key] = name.split(".");

    if (key === "instancesOfDataBreaches" && !validateNumberInput(value))
      return;
    if (
      key === "percentageInvolvingPersonalData" &&
      !validatePercentageInput(value)
    )
      return;

    if (
      name === "consumerComplaintsMechanisms" ||
      name === "correctiveActions"
    ) {
      setFormData((prev) => ({
        ...prev,
        [name]: value, // Update the specific key
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: {
          ...prev[field], // Correctly access the dynamic field
          [key]: value, // Update the specific key
        },
      }));
    }

    setErrors((prev) => ({
      ...prev,
      [name]: "", // Update the specific key
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    const turnover = {};
    Object.keys(formData.turnoverPercentageWithInformation).forEach((key) => {
      const value = formData.turnoverPercentageWithInformation[key];
      if (
        !value ||
        value === "" ||
        (typeof value === "string" && value.trim() === "")
      ) {
        turnover[key] = "This field is Required";
      }
    });
    setErrors((prev) => ({
      ...prev,
      turnoverPercentageWithInformation: turnover,
    }));

    if (
      !formData?.consumerComplaintsMechanisms ||
      (typeof formData?.consumerComplaintsMechanisms === "string" &&
        formData?.consumerComplaintsMechanisms?.trim() === "")
    )
      newErrors["consumerComplaintsMechanisms"] = "This field is Required";

    const urlPattern =
      /^(https?:\/\/)?(www\.)?(([\p{L}0-9-]+\.)+[\p{L}]{2,}|(\d{1,3}\.){3}\d{1,3})(:\d{2,5})?(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/u;
    // if (!formData?.antiCorruptionPolicy?.policyLink?.trim())
    //   newErrors["antiCorruptionPolicy.policyLink"] = "Required";

    if (
      !formData?.correctiveActions ||
      (typeof formData?.correctiveActions === "string" &&
        formData?.correctiveActions?.trim() === "")
    )
      newErrors["correctiveActions"] = "This field is Required";

    if (formData?.cyberSecurityAndDataPrivacyPolicy?.action) {
      const webLink = formData?.cyberSecurityAndDataPrivacyPolicy?.webLink;
      if (!webLink || (typeof webLink === "string" && webLink.trim() === ""))
        newErrors["cyberSecurityAndDataPrivacyPolicy.webLink"] =
          "This field is Required";
      else if (typeof webLink === "string" && !urlPattern.test(webLink.trim()))
        newErrors["cyberSecurityAndDataPrivacyPolicy.webLink"] =
          "Enter a valid URL";
    }

    if (
      formData?.dataBreachDetails?.instancesOfDataBreaches === "" ||
      !validateNumber(formData?.dataBreachDetails?.instancesOfDataBreaches)
    )
      newErrors["dataBreachDetails.instancesOfDataBreaches"] = numberError;

    if (
      formData?.dataBreachDetails?.percentageInvolvingPersonalData === "" ||
      !validateNumber(
        formData?.dataBreachDetails?.percentageInvolvingPersonalData,
      )
    )
      newErrors["dataBreachDetails.percentageInvolvingPersonalData"] =
        percentageError;

    if (
      !formData?.dataBreachDetails?.impactOfDataBreaches ||
      (typeof formData?.dataBreachDetails?.impactOfDataBreaches === "string" &&
        formData?.dataBreachDetails?.impactOfDataBreaches?.trim() === "")
    )
      newErrors["dataBreachDetails.impactOfDataBreaches"] =
        "This field is Required";

    if (!formData?.cyberSecurityAndDataPrivacyPolicy?.action)
      setFormData((prev) => ({
        ...prev,
        cyberSecurityAndDataPrivacyPolicy: {
          ...prev.cyberSecurityAndDataPrivacyPolicy,
          webLink: "",
        },
      }));

    setErrors((prev) => ({
      ...prev, // Spread the previous errors
      ...newErrors, // Update or add the new error for the specific field (or name)
    }));
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      let v1 = validateFields(
        currentTable,
        inputData.currentYearData,
        defaultSegments.currentFinancialYear,
        setErrors,
        errors,
        "currentFinancialYear",
      );
      let v2 = validateFields(
        previousTable,
        inputData.currentYearData,
        defaultSegments.currentFinancialYear,
        setErrors,
        errors,
        "previousFinancialYear",
      );
      let v3 = validateFields(
        productTable,
        inputData.productData,
        defaultSegments.products,
        setErrors,
        errors,
        "productRecalls",
      );
      // let v4 = validateTable(inputData?.appealData, tables, setTabErrors);
      let v4 = validateForm();
      if (!v1 || !v2 || !v3 || !v4) return;

      let transformedData2 = {
        essentialIndicators: {
          ...formData,
          consumerComplaints: {
            currentFinancialYear: currentTable,
            previousFinancialYear: previousTable,
          },
          productRecalls: productTable,
        },
        essentialIndicatorsSubmitted: true,
        type: "SectionC",
        subType: "principle9",
      };

      try {
        const res = await put(`/brsr/update?id=${id}`, transformedData2);

        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        onSave();
      } catch (error) {
        console.log(error);
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else onSave();
  };

  useEffect(() => {
    const action = formData?.cyberSecurityAndDataPrivacyPolicy?.action;

    // When action is false or "false" → clear webLink
    if (action === false || action === "false") {
      setFormData((prev) => ({
        ...prev,
        cyberSecurityAndDataPrivacyPolicy: {
          ...prev.cyberSecurityAndDataPrivacyPolicy,
          webLink: "",
        },
      }));
    }
  }, [formData?.cyberSecurityAndDataPrivacyPolicy?.action]);

  return (
    <Box>
      <p className={style.subHeading}>I. ESSENTIAL INDICATOR</p>
      <MessagePopup {...{ snackOpen, setsnackOpen }} /> {/* 1 */}
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", my: "1rem" }}>
        1. Describe the mechanisms in place to receive and respond to consumer
        complaints and feedback.
      </Typography>
      <Box sx={{ ml: 2.2, width: "98%" }}>
        <Multiline
          {...{
            handleChange,
            disabled,
            rows: 3,
            placeholder: "Describe here",
            errors: errors["consumerComplaintsMechanisms"] && true,
            fieldName: "consumerComplaintsMechanisms",
            value:
              formData?.consumerComplaintsMechanisms === 0
                ? 0
                : formData?.consumerComplaintsMechanisms || "",
          }}
        />
        <p
          color="error"
          variant="caption"
          style={{
            lineHeight: "1.2",
            margin: "2px 0",
            marginTop: "5px",
            color: "#d34040",
            fontSize: "10px",
            fontStyle: "italic",
          }}
        >
          {errors["consumerComplaintsMechanisms"]}
        </p>
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "complaintMechanismsDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* 2 */}
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", my: "1rem" }}>
        2. Turnover of products and/ services as a percentage of turnover from
        all products/service that carry information about:
      </Typography>
      <Box sx={{ ml: 2 }}>
        <SingleColumn
          {...{
            formData,
            disabled,
            setFormData,
            setErrors,
            errors: errors["turnoverPercentageWithInformation"],
          }}
        />
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "turnoverDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* 3 */}
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Box>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", my: "1rem" }}>
          3. Number of consumer complaints in respect of the following:
        </Typography>{" "}
        <Box sx={{ display: "flex", gap: 1, ml: 1.5, mt: 3, mb: "-1rem" }}>
          <CircleIcon sx={{ fontSize: "6px", mt: 1.2, ml: 0.7 }} />
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", fontSize: "15px" }}
          >
            In Current Financial Year
          </Typography>
        </Box>
        <TableData
          defaultColumn="Category"
          disabled={disabled}
          defaultWidth="12rem"
          defaultSegments={defaultSegments?.currentFinancialYear || ""}
          inputData={inputData?.currentYearData}
          errors={errors["currentFinancialYear"]}
          setErrors={setErrors}
          tables={currentTable}
          setTables={setCurrentTable}
          name="currentFinancialYear"
        />
        {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
        <Box sx={{ display: "flex", gap: 1, ml: 1.5, mt: 1, mb: "-1rem" }}>
          <CircleIcon sx={{ fontSize: "6px", mt: 1, ml: 0.7 }} />
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", fontSize: "15px" }}
          >
            {" "}
            In Previous Financial Year
          </Typography>
        </Box>
        <TableData
          defaultColumn="Category"
          disabled={disabled}
          defaultWidth="12rem"
          defaultSegments={defaultSegments?.currentFinancialYear || ""}
          inputData={inputData?.currentYearData}
          errors={errors["previousFinancialYear"]}
          setErrors={setErrors}
          tables={previousTable}
          setTables={setPreviousTable}
          name="previousFinancialYear"
        />
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "consumerComplaintsDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* 4 */}
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", my: "0.5rem" }}>
        4. Details of instances of product recalls on account of safety issues:
      </Typography>{" "}
      <TableData
        disabled={disabled}
        defaultColumn="Name of authority"
        defaultWidth="10rem"
        defaultSegments={defaultSegments?.products || ""}
        inputData={inputData?.productData}
        errors={errors["productRecalls"]}
        setErrors={setErrors}
        tables={productTable}
        setTables={setProductTable}
        name="productRecalls"
      />
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "productRecallsDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* 5 */}
      <RadioButtons
        ml={2.5}
        disabled={disabled}
        title={
          "5. Does the entity have a framework/ policy on cyber security and risks related to data privacy? (Yes/No) If available, provide a web-link of the policy."
        }
        value={formData?.cyberSecurityAndDataPrivacyPolicy?.action || false}
        handleChange={(e) => {
          const value = e.target.value === "true";
          setFormData((prev) => ({
            ...prev,
            cyberSecurityAndDataPrivacyPolicy: {
              ...prev.cyberSecurityAndDataPrivacyPolicy,
              action: value,
            },
          }));
          setErrors((prev) => ({
            ...prev,
            cyberSecurityAndDataPrivacyPolicy: {
              webLink: "",
            },
          }));
        }}
      />
      {formData?.cyberSecurityAndDataPrivacyPolicy?.action && (
        <Box sx={{ ml: 2 }}>
          <InputField
            disabled={disabled}
            handleChange={handleChange}
            fieldName="cyberSecurityAndDataPrivacyPolicy.webLink"
            errors={errors["cyberSecurityAndDataPrivacyPolicy.webLink"] && true}
            placeholder={"Enter Text"}
            mt={1}
            value={
              formData?.cyberSecurityAndDataPrivacyPolicy?.webLink === 0
                ? 0
                : formData?.cyberSecurityAndDataPrivacyPolicy?.webLink || ""
            }
          />
          <p
            color="error"
            variant="caption"
            style={{
              lineHeight: "1.2",
              margin: "2px 0",
              marginTop: "5px",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
            }}
          >
            {errors["cyberSecurityAndDataPrivacyPolicy.webLink"]}
          </p>
        </Box>
      )}
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "cyberSecurityDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* 6 */}
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: "bold",
          my: "1rem",
          textIndent: "-1.1rem",
          ml: "1rem",
        }}
      >
        6. Provide details of any corrective actions taken or underway on issues
        relating to advertising, and delivery of essential services; cyber
        security and data privacy of customers; re-occurrence of instances of
        product recalls; penalty / action taken by regulatory authorities on
        safety of products / services.
      </Typography>
      <Box sx={{ ml: 2, width: "98%" }}>
        <Multiline
          {...{
            handleChange,
            disabled,
            rows: 3,
            placeholder: "Describe here",
            errors: errors["correctiveActions"] && true,
            fieldName: "correctiveActions",
            value: formData?.correctiveActions,
          }}
        />
        <p
          color="error"
          variant="caption"
          style={{
            lineHeight: "1.2",
            margin: "2px 0",
            marginTop: "5px",
            color: "#d34040",
            fontSize: "10px",
            fontStyle: "italic",
          }}
        >
          {errors["correctiveActions"]}
        </p>
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "correctiveActionsDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* 7 */}
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", my: "1rem" }}>
        7. Provide the following information relating to data breaches:
      </Typography>
      <Box sx={{ display: "flex", gap: 2, ml: 2 }}>
        <Box sx={{ display: "flex", flexDirection: "column", width: "50%" }}>
          <Typography
            sx={{
              fontWeight: 500,
              fontFamily: "Inter",
              fontSize: "15px",
              lineHeight: "22px",
              mt: 3,
            }}
          >
            (a) Number of instances of data breaches
          </Typography>
        </Box>
        <Box sx={{ width: "50%" }}>
          <Typography
            sx={{
              fontWeight: 500,
              fontFamily: "Inter",
              fontSize: "15px",
              lineHeight: "22px",
            }}
          >
            (b) % of data breaches involving personally identifiable information
            of customers
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", gap: 2, ml: 2 }}>
        <Box sx={{ display: "flex", flexDirection: "column", width: "50%" }}>
          <InputField
            {...{
              handleChange,
              disabled,
              placeholder: "Enter Number",
              errors:
                errors["dataBreachDetails.instancesOfDataBreaches"] && true,
              fieldName: "dataBreachDetails.instancesOfDataBreaches",
              value:
                formData?.dataBreachDetails?.instancesOfDataBreaches === 0
                  ? 0
                  : formData?.dataBreachDetails?.instancesOfDataBreaches || "",
            }}
          />
          <p
            color="error"
            variant="caption"
            style={{
              lineHeight: "1.2",
              margin: "2px 0",
              marginTop: "5px",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
            }}
          >
            {errors["dataBreachDetails.instancesOfDataBreaches"]}
          </p>
        </Box>
        <Box sx={{ width: "50%" }}>
          <InputField
            {...{
              handleChange,
              disabled,
              errors:
                errors["dataBreachDetails.percentageInvolvingPersonalData"] &&
                true,
              placeholder: "Enter Percentage",
              fieldName: "dataBreachDetails.percentageInvolvingPersonalData",
              value:
                formData?.dataBreachDetails?.percentageInvolvingPersonalData ===
                0
                  ? 0
                  : formData?.dataBreachDetails
                      ?.percentageInvolvingPersonalData || "",
            }}
          />
          <p
            color="error"
            variant="caption"
            style={{
              lineHeight: "1.2",
              margin: "2px 0",
              marginTop: "5px",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
            }}
          >
            {errors["dataBreachDetails.percentageInvolvingPersonalData"]}
          </p>
        </Box>
      </Box>
      <Typography
        sx={{
          fontWeight: 500,
          fontFamily: "Inter",
          fontSize: "15px",
          lineHeight: "22px",
          mt: "1rem",
          ml: 2,
        }}
      >
        (c) Impact, if any, of the data breaches{" "}
      </Typography>
      <Box sx={{ ml: 2 }}>
        <Multiline
          {...{
            handleChange,
            disabled,
            rows: 3,
            placeholder: "Enter Text",
            errors: errors["dataBreachDetails.impactOfDataBreaches"] && true,
            fieldName: "dataBreachDetails.impactOfDataBreaches",
            value:
              formData?.dataBreachDetails?.impactOfDataBreaches === 0
                ? 0
                : formData?.dataBreachDetails?.impactOfDataBreaches || "",
          }}
        />
        <p
          color="error"
          variant="caption"
          style={{
            lineHeight: "1.2",
            margin: "2px 0",
            marginTop: "5px",
            color: "#d34040",
            fontSize: "10px",
            fontStyle: "italic",
          }}
        >
          {errors["dataBreachDetails.impactOfDataBreaches"]}
        </p>
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "dataBreachDetailsDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {/* Submit Button */}
      {!hide && (
        <>
          {brsrReview ? (
            <Box sx={{ ml: "1rem", width: "98.4%" }}>
              <ReviewBox
                url={`/brsr/review/${id}`}
                handleSubmit={handleSubmit}
              />
            </Box>
          ) : (
            <Box textAlign="right" sx={{ mt: 3 }}>
              <Button
                onClick={handleSubmit}
                variant="contained"
                sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
              >
                Save & Continue <EastIcon sx={{ ml: 2 }} />
              </Button>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default EssentialIndicator;
